// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__AImGC","transparent":"Backdrop_transparent__bk+lY"};